import { render, staticRenderFns } from "./archived-activities.vue?vue&type=template&id=b4b5059e&"
import script from "./archived-activities.vue?vue&type=script&lang=js&"
export * from "./archived-activities.vue?vue&type=script&lang=js&"
import style0 from "./archived-activities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "archived-activities.vue"
export default component.exports